export default __webpack_public_path__ + "static/media/virusyellow-250-3-min.ae47b29e.png";